import React from 'react';
import { Typography, Grid, Card, CardMedia, CardContent, Box, Stack } from '@mui/material';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import PersonIcon from "@mui/icons-material/Person";

import Footer from "../../components/Footer";

import mainBlogThumbnail from '../../assets/images/thumbnails/blogs/main-blog-thumbnail.png';
import secondaryBlogThumbnail from '../../assets/images/thumbnails/blogs/secondary-blog-thumbnail.png';

import blogThumbnail1 from '../../assets/images/thumbnails/blogs/blog1.png';
import blogThumbnail2 from '../../assets/images/thumbnails/blogs/blog2.png';
import blogThumbnail3 from '../../assets/images/thumbnails/blogs/blog3.png';
import blogThumbnail4 from '../../assets/images/thumbnails/blogs/blog4.png';

const SingleBlogPage = () => {

  const blogPost = {
    title: "Blog Post Title Goes Here",
    subtitle: "Design That Pays: Adding Value Through Innovation",
    date: "23 APR 2025",
    author: "Denisa Stănilă",
    shortDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    mainPicture: mainBlogThumbnail,
    secondaryPicture: secondaryBlogThumbnail,
    longDescription: [
      {
        sectionTitle: "The standard Lorem Ipsum passage, used since the 1500s",
        content: `"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."`
      },
      {
        sectionTitle: "1914 translation by H. Rackham",
        content: `"But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful. Nor again is there anyone who loves or pursues or desires to obtain pain of itself, because it is pain, but because occasionally circumstances occur in which toil and pain can procure him some great pleasure. To take a trivial example, which of us ever undertakes laborious physical exercise, except to obtain some advantage from it? But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one who avoids a pain that produces no resultant pleasure?"`
      },
      {
        sectionTitle: "Section 1.10.33 of 'de Finibus Bonorum et Malorum'",
        content: `"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis doloribus asperiores repellat."`
      },
      {
        sectionTitle: "1914 translation by H. Rackham",
        content: `"On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire, that they cannot foresee the pain and trouble that are bound to ensue; and equal blame belongs to those who fail in their duty through weakness of will, which is the same as saying through shrinking from toil and pain. These cases are perfectly simple and easy to distinguish. In a free hour, when our power of choice is untrammelled and when nothing prevents our being able to do what we like best, every pleasure is to be welcomed and every pain avoided. But in certain circumstances and owing to the claims of duty or the obligations of business it will frequently occur that pleasures have to be repudiated and annoyances accepted. The wise man therefore always holds in these matters to this principle of selection: he rejects pleasures to secure other greater pleasures, or else he endures pains to avoid worse pains."`
      }
    ]
  };

  
  const CustomAuthorDots = ({ dots }) => (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        marginTop: "10px", // Add spacing from the slider
      }}
    >
      {dots.map((dot, index) => (
        <Box
          key={index}
          onClick={dot.props.onClick}
          sx={{
            width: "7px",
            height: "7px",
            borderRadius: "50%",
            backgroundColor: dot.props.className.includes("slick-active")
              ? "#189AB4" // Active dot color
              : "#D9D9D9", // Inactive dot color
            cursor: "pointer",
            transition: "background-color 0.3s ease",
          }}
        />
      ))}
    </Box>
  );

  const mobileCarouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false, // Hide arrows for mobile
    appendDots: (dots) => <CustomAuthorDots dots={dots} />,
  };

  const similarBlogPosts = [
    {
      id: 1,
      title: "Design That Pays: Adding Value Through Innovation",
      date: "2 NOV 2024",
      author: "Andreea Birsan",
      excerpt:
        "Small design changes can make a big impact on your property’s value. This blog explores the easiest and most effective updates to create a space that looks amazing and sells even better.",
      image: blogThumbnail1, 
    },
    {
      id: 2,
      title: "2025, the Year of Financial Mastery",
      date: "30 OCT 2024",
      author: "Marian Papară",
      excerpt:
        "Step into the future with confidence. Discover key strategies to master your finances, achieve your goals, and turn 2025 into your most successful year yet.",
      image: blogThumbnail2, 
    },
    {
      id: 3,
      title: "Boosting Financial Growth with Tech and Tokens",
      date: "22 OCT 2024",
      author: "Diana Chirtop",
      excerpt:
        "In today's fast-paced digital world, leveraging innovative technology can be key to achieving financial growth. Portable SSDs, like the one pictured above, symbolize the efficiency and security needed to store digital assets safely.",
      image: blogThumbnail3, 
    },
    {
      id: 4,
      title: "Adventures with a Purpose: Driving Towards Wealth",
      date: "16 OCT 2024",
      author: "Sabina Bodea",
      excerpt:
        "Embark on a journey where financial freedom meets the thrill of exploration. Learn how to align your financial goals with your passions, creating a roadmap for wealth and adventure that fuels both your wallet and your soul.",
      image: blogThumbnail4, 
    },
  ];

  return (
    <Box sx={{ py: { xs: 2, xxl: 6 }, px: { xs: 2, xxl: 0 }, backgroundColor: "#fff" }}>
      <Box sx={{ margin: "0 auto", width: { xs: "100%", xxl: "67%" } }}>
        
        {/* Title Section */}
        <Box 
          sx={{
            mb: { xs: 2, xxl: 6 }
          }}
        >
          <Box sx={{ display: { xs: "block", xxl: "flex" }, justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <Box sx={{ display: "flex", flexDirection: { xs: "row", xxl: "column" } }}>
              <Typography 
                variant="h2" 
                sx={{
                  color: "#189AB4",
                  fontWeight: "bold",
                  mb: { xs: 1, xxl: 0}
                }}
              >
                {blogPost.title}
              </Typography>
            </Box>

            {/* Right Side: Date and Author */}
            <Box sx={{ display: "flex", flexDirection: "row", alignItems: "flex-end", gap: 4 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CalendarTodayIcon sx={{ fontSize: "16px", color: "#B7B7B7" }} />
                <Typography variant="body2" sx={{ fontSize: "12px", color: "#B7B7B7" }}>
                  {blogPost.date}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <PersonIcon sx={{ fontSize: "16px", color: "#B7B7B7" }} />
                <Typography variant="body2" sx={{ fontSize: "12px", color: "#B7B7B7" }}>
                  {blogPost.author}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Subtitle */}
          <Typography 
            variant="h4" 
            sx={{
              fontWeight: "500",
              color: "#0A435E",
              mb: { xs: 2, xxl: 4 }
            }}
          >
            {blogPost.subtitle}
          </Typography>

          {/* Short Description */}
          <Typography 
            variant="body1" 
            sx={{ fontSize: "16px", fontWeight: "bold", color: "#000" }}
          >
            {blogPost.shortDescription}
          </Typography>
        </Box>

        {/* Main Image */}
        <Box textAlign="center">
          <CardMedia
            component="img"
            image={blogPost.mainPicture}
            alt="Main blog image"
            sx={{ 
              mb: { xs: 2, xxl: 8 },
              width: "100%",
              height: { xs: "259px", xxl: "630"},
              borderRadius: 4,
              margin: "0 auto",
              display: "block",
            }}
            
          />
        </Box>

        {/* Blog Content */}
        <Box 
          sx={{ 
            color: "#000",
            mb: { xs: 2, xxl: 6 }, 
            position: "relative" 
          }}
        >
          {/* Secondary Image floated right */}
          <Box
            component="img"
            src={blogPost.secondaryPicture}
            alt="Secondary blog image"
            sx={{
              float: { xxl: "right" },
              width: { xs: "388px", xxl: "500px" },
              height: { xs: "259px", xxl: "auto" },
              borderRadius: 4,
              mt: { xs: 0, xxl: 18},
              ml: { xxl: 4 },
              mb: { xs: 2, xxl: 0 },
            }}
          />

          {/* Text Content */}
          {blogPost.longDescription.map((section, index) => (
            <Box key={index} 
              sx={{
                mb: { xs: 2, xxl: 6 }
              }} 
            >
              <Typography variant="h6" color="#000" gutterBottom>
                {section.sectionTitle}
              </Typography>
              <Typography variant="body1" paragraph>
                {section.content}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>

      {/* Similar Blog Posts Section */}
      <Box sx={{ py: { xs: 2, xxl: 6 }, px: { xs: "10px", xxl: "0" },  textAlign: "center", width: "100%", backgroundColor: "#fff" }}>
        <Typography
          variant="h4"
          sx={{
            mb: { xs: 2, xxl: 4 },
            fontWeight: "bold", 
            color: '#189AB4',
          }}
        >
          Similar Blog Posts
        </Typography>

        {/* Blog Posts */}
        <Box
          sx={{
            display: { xs: "none", xxl: "flex" },
            flexWrap: "wrap",
            gap: 4,
            justifyContent: "center",
            maxWidth: "67%",
            margin: "0 auto",
          }}
        >
          {similarBlogPosts.map((post) => (
            <Box
              key={post.id}
              sx={{
                flex: "1 1 calc(20% - 16px)", 
                width: "242px",
                borderRadius: "16px",
                overflow: "hidden",
                border: "1px solid #189AB4",
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
              }}
            >
              <Card
                sx={{
                  borderRadius: "16px",
                  overflow: "hidden",
                  height: "100%",
                }}
                component={Link} 
                to={`/blogs/blog/${post.id}`}
              >
                <CardMedia
                  component="img"
                  height="150"
                  image={post.image}
                  alt={post.title}
                  sx={{
                    borderRadius: "0px",
                    margin: 0
                  }}
                />
                <CardContent sx={{ textAlign: "left", p: 2 }}>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ mb: 1 }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <CalendarTodayIcon sx={{ fontSize: "16px", color: "#B7B7B7" }} />
                      <Typography
                        variant="body2"
                        sx={{ fontSize: "12px", color: "#B7B7B7" }}
                      >
                        {post.date}
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <PersonIcon sx={{ fontSize: "16px", color: "#B7B7B7" }} />
                      <Typography
                        variant="body2"
                        sx={{ fontSize: "12px", color: "#B7B7B7" }}
                      >
                        {post.author}
                      </Typography>
                    </Box>
                  </Stack>
                  <Typography
                    variant="h4"
                    sx={{
                      mt: 1,
                      color: "#189AB4",
                      textTransform: "none",
                      fontWeight: "bold", 
                      fontSize: "20px", 
                      lineHeight: "20px",
                      letterSpacing: "normal", 
                    }}

                  >
                    {post.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      mt: 1,
                      color: "#000",
                      textTransform: "none",
                      fontWeight: "300", 
                      fontSize: "14px", 
                      lineHeight: "14px",
                      letterSpacing: "normal", 
                    }}
                  >
                    {post.excerpt}
                  </Typography>
                </CardContent>
              </Card>
            </Box>
          ))}
        </Box>

        {/* Mobile Slider */}
        <Box sx={{ display: { xs: "block", xxl: "none" } }}>
          <Slider {...mobileCarouselSettings}>
            {similarBlogPosts.map((post) => (
              <Box
                key={post.id}
                sx={{
                  width: "50%",
                  borderRadius: "16px",
                  overflow: "hidden",
                  border: "1px solid #189AB4",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                  margin: "10px 0px",
                }}
              >
                <Card
                  sx={{
                    width: "100%",
                    borderRadius: "16px",
                    overflow: "hidden",
                  }}
                >
                  <CardMedia
                    component="img"
                    height="139"
                    image={post.image}
                    alt={post.title}
                    sx={{
                      borderRadius: "0px",
                      margin: 0,
                    }}
                  />
                  <CardContent sx={{ textAlign: "left", p: 2 }}>
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      sx={{ mb: 1 }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <CalendarTodayIcon sx={{ fontSize: "12px", color: "#B7B7B7" }} />
                        <Typography
                          variant="body3"
                          sx={{ color: "#B7B7B7" }}
                        >
                          {post.date}
                        </Typography>
                      </Box>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <PersonIcon sx={{ color: "#B7B7B7" }} />
                        <Typography
                          variant="body3"
                          sx={{ fontSize: "12px", color: "#B7B7B7" }}
                        >
                          {post.author}
                        </Typography>
                      </Box>
                    </Stack>
                    <Typography
                      variant="h5"
                      sx={{
                        mt: 1,
                        color: "#189AB4",
                        textTransform: "none",
                        fontWeight: "bold",
                        letterSpacing: "normal",
                      }}
                    >
                      {post.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        mt: 1,
                        color: "#000",
                        textTransform: "none",
                        fontWeight: "300",
                        letterSpacing: "normal",
                      }}
                    >
                      {post.excerpt}
                    </Typography>
                  </CardContent>
                </Card>
              </Box>
            ))}
          </Slider>
        </Box>
      </Box>

      <Footer/>
    </Box>
  );
};

export default SingleBlogPage;